import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { MgdRouterService } from "../services/mgd-router.service";

/**
 * When attached to a route it will set the errorMessage data to the navigation state's error message
 */
export const errorMessageResolver: ResolveFn<string | null> = () => {

    const router = inject(MgdRouterService);
    return router.navigationErrorMessage;
};
